'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _coderreviewed = require('./coderreviewed.component');

var _coderreviewed2 = _interopRequireDefault(_coderreviewed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coderreviewedModule = _angular2.default.module('coderreviewed', [_angularUiRouter2.default]).component('coderreviewed', _coderreviewed2.default);

exports.default = coderreviewedModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/coderreviewed/coderreviewed.js